import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Paste your config here (from Step 3A)
const firebaseConfig = {
    apiKey: "AIzaSyCPY6d8deKQD7oq9udsOTKkxA2RI7WP3QU",
    authDomain: "pokreg-309a4.firebaseapp.com",
    projectId: "pokreg-309a4",
    storageBucket: "pokreg-309a4.firebasestorage.app",
    messagingSenderId: "73676268242",
    appId: "1:73676268242:web:88ac9b54ef58c83769830b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
